const singleJobPost = document.querySelector('.single-job-post');
if (singleJobPost) {
  document.body.classList.add('hide-overlay');
  const modalButton = singleJobPost.querySelector('.form-modal-btn');

  // Visible After Top Heading On Page
  if (modalButton) {
    const jobHeader = singleJobPost.querySelectorAll('.single-job-post__left');
    const bottomBar = singleJobPost.querySelector('.single-job-post__mobile-button');

    const sectionObserve = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            bottomBar.classList.remove('is-open');
          } else {
            bottomBar.classList.add('is-open');
          }
        });
      },
      { threshold: 0 },
    );

    jobHeader.forEach((element) => {
      sectionObserve.observe(element);
    });

    // Open Form
    const bottomBarButton = bottomBar.querySelector('.btn');
    bottomBarButton.addEventListener('click', () => {
      modalButton.click();
    });

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        bottomBar.removeAttribute('hidden');
      }, 300);
    });
  }
}
